module.exports = __webpack_public_path__ + "14b39041b9bf6d207172b9a26e35d356.woff";


//////////////////
// WEBPACK FOOTER
// ./src/font/31E6D3_0_0.woff
// module id = 2245
// module chunks = 2